var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTele2Bw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1823,
    height: 1341,
    viewBox: "0 0 1823 1341",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M273 325H0V598H273V325Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1017 1067.74V1341H744.221C690.306 1341 638.703 1330.94 591.165 1312.54C431.519 1250.94 318 1095.82 318 914.631V0H591.165V325.223H907.974V598.525H591.165V1067.74H1017Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1802 1068H1063V1341H1802V1068Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1823 597.979C1823 651.862 1812.94 703.436 1794.57 750.948C1732.92 910.503 1577.71 1024 1396.48 1024H1062.48V750.948H1396.48C1481.08 750.948 1549.63 682.482 1549.63 597.979C1549.63 513.476 1481.08 445.052 1396.48 445.052C1341.33 445.052 1293 474.175 1266.02 517.88C1251.64 541.187 1243.33 568.599 1243.33 597.979V598.406H970V597.979C970 583.31 970.728 568.856 972.226 554.572C981.003 467.889 1015.98 388.817 1069.07 325.354C1147.34 231.699 1265.04 172 1396.48 172C1631.66 172 1823 363.115 1823 597.979Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTele2Bw);
export default __webpack_public_path__ + "static/media/Logo_Tele2_BW.cdbd2f6c8640e4d69129ef1e7627d1ab.svg";
export { ForwardRef as ReactComponent };